﻿import { Component } from '@angular/core';

@Component({
    selector: 'unauthorized',
    templateUrl: './unauthorized.component.html'
})
export class UnauthorizedComponent {
    header: string = "401 Unauthorized";
}